var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.loadingWrapper},[(_vm.loading)?_c('a-spin',[_c('a-icon',{attrs:{"slot":"indicator","component":_vm.IconWait,"spin":""},slot:"indicator"})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }